import { Component, OnInit } from '@angular/core';
import { ContentServiceService } from 'src/app/service/content-service.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PortalService } from 'src/app/service/portal.service';

@Component({
  selector: 'app-view-games',
  templateUrl: './view-games.component.html',
  styleUrls: ['./view-games.component.css']
})
export class ViewGamesComponent implements OnInit {
  showModalBox: boolean = false;
  discrib: boolean = false;
  viewGamesData: any;
  categoryid: any;
  categoryName: any;
  discrb: string;

  constructor(private contentService: ContentServiceService,
    private _activatedRoute: ActivatedRoute,
    private portalService: PortalService,
    private _router: Router,
    private location: Location,
  ) { }

  ngOnInit(): void {

    this.categoryid = this._activatedRoute.snapshot.paramMap.get('id');
    this.categoryName = this._activatedRoute.snapshot.paramMap.get('name');
    this.getViewGamesData()

    if (sessionStorage.getItem('isSubscribed') == '0') {
      this.showModal();
      console.log('isSubscribed=========', sessionStorage.getItem('isSubscribed') == '0');
    }
  }

  showModal() {
    console.log("click");
    this.showModalBox = true
  }
  closeModal() {
    console.log("click");

    this._router.navigateByUrl('/lp')
    this.showModalBox = false;
  }

  discribModal(i, dis) {
    this.discrib = true;
    this.discrb = dis
  }
  closedis() {
    this.discrib = false;
  }

  getViewGamesData() {
    let endpoint = "portal/categoryContent";
    let data = {
      "data": {
        "categoryid": this.categoryid,
      }
    }

    this.contentService.getContentById(data, endpoint)
      .then(response => {
        if (response['success']) {
          console.log("Success..", response)
          this.viewGamesData = response['data']['content'];
          console.log("viewGamesData", this.viewGamesData);
        }
      })
      .catch(error => {
        console.log("Error", error);
        //this._router.navigate(['/content-management/portal'])
      })
  }

  //downloadLog   this
  downloadLog(contentName) {
    this.portalService.downloadLogEntry(contentName)
  }
  back(): void {
    this.location.back()
    //this.router.navigate(['home'])
  }

}
